export default __webpack_public_path__ + "static/media/backtothefuture.d0e3ff59.png";